<div class="course-assignments">
  <div class="course-assignments__card">
    <div class="course-assignments__header">
      <h2 class="course-assignments__title">
        {{ 'app.components.courseCreator.assign.selectTitle' | translate }}
      </h2>
    </div>

    <div class="course-assignments__inner">
      <p class="course-assignments__hint">
        {{ 'app.components.courseCreator.assign.hint' | translate }}
      </p>

      <div class="course-assignments__add">
        <div class="course-assignments__input-wrap">
          <app-input-field
            [formControl]="inviteCodeControl"
            [placeholder]="'app.components.courseCreator.assign.inputPlaceholder' | translate"
            [disabled]="!courseId()"
          ></app-input-field>
        </div>
        <button
          type="button"
          class="course-assignments__add-btn"
          (click)="onAddStudent()"
          [disabled]="!courseId() || isAdding()"
        >
          {{ (isAdding() ? 'app.components.courseCreator.assign.adding' : 'app.components.courseCreator.assign.addAnother') | translate }}
        </button>
      </div>

      @if (addError()) {
        <p class="course-assignments__error">{{ addError() }}</p>
      }

      <div class="course-assignments__list">
        @if (studentItems().length === 0) {
          <p class="course-assignments__empty">
            {{ 'app.components.courseCreator.assign.empty' | translate }}
          </p>
        } @else {
          <div class="course-assignments__students">
            @for (item of paginatedStudents(); track item.userId) {
              <div class="course-assignments__student-row">
                <app-student-compact-view [item]="item"></app-student-compact-view>
                <button
                  type="button"
                  class="course-assignments__remove"
                  (click)="onRemoveStudent(item.userId)"
                  [title]="'app.components.courseCreator.assign.remove' | translate"
                >
                  ×
                </button>
              </div>
            }
          </div>

          @if (totalPages() > 1) {
            <div class="course-assignments__pagination">
              <button
                type="button"
                class="course-assignments__page-btn"
                (click)="goToPage(currentPage() - 1)"
                [disabled]="currentPage() <= 1"
              >
                {{ 'app.components.courseCreator.assign.pagination.prev' | translate }}
              </button>
              <span class="course-assignments__page-info">
                {{ 'app.components.courseCreator.assign.pagination.page' | translate : { current: currentPage(), total: totalPages() } }}
              </span>
              <button
                type="button"
                class="course-assignments__page-btn"
                (click)="goToPage(currentPage() + 1)"
                [disabled]="currentPage() >= totalPages()"
              >
                {{ 'app.components.courseCreator.assign.pagination.next' | translate }}
              </button>
            </div>
          }
        }
      </div>
    </div>
  </div>

  <div class="course-assignments__actions">
    <app-cta-button variant="light" size="small" (clicked)="onComplete()">
      <span cta-label>{{ 'app.components.courseCreator.assign.complete' | translate }}</span>
    </app-cta-button>
  </div>
</div>
